/* eslint-disable security/detect-object-injection */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import  { Suspense,useContext,useEffect,useState,useCallback } from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import React from 'react';
import {logout,setUserType,verifyOtp} from '../pages/auth/authSlice'
import {CognitoCurrentData,CognitoData} from '../CommonMethods/CognitoData'
import {Route,Navigate,Routes,useNavigate,useLocation} from 'react-router-dom';
import GlobalContext from '../components/Context/GloablContext';
import AnimatedPage from '../components/Animation/AnimatedPage';
import LoginPage from '../pages/auth/LoginForm';
import { ComponentsBasedOnRole } from './_nav';
import { handleIsUserScreen, handleIsViewScreen, handleLocationKey, resetFilterState, resetState ,handleEditMessageSent,handleTargetUserEditId} from '../redux/systemConfigSlice';
import { resetArrays } from '../redux/MultiselectRows';
import Layout from '../components/Layout';
import SideBar from '../components/Layout/Sidebar';
import Noroute from '../components/Noroutes';
import SearchEmptyScreen from '../components/SearchEmptyScreen';
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword';
import { resetOrgList } from '../pages/ManageOrganizations/usersSlice';
import { resetMonitorList } from '../pages/ManageOrganizations/monitorsSlice';
import ForgotResetPassword from '../pages/auth/LoginForm/Components/ForgotResetPassword';
import { resetSubDivList } from '../pages/ManageAdminAndCoporateUser/subdivisionSlice';
import { handleSidebarAnimation } from '../redux/commonSlice';
import { resetObserverList } from '../pages/ManageOrganizations/observersSlice';
import { userService } from '../services/user.services';
import { dataService } from '../services/data.services';
import UpdatePassword from '../pages/Profile/UpdatePassword.jsx';
import EmailVerificationScreen from '../CommonMethods/EmailAddressVerification.jsx';
import refreshIdToken from '../CommonMethods/RefreshIdFunction.jsx';
import { resetProviderList } from '../pages/ManageOrganizations/providersSlice.js';

export default function NavigationRoutes(props) {
    const dispactch=useDispatch()
    const [loading, setloading] = useState(true)
    const [CurrentUser, setCurrentUser] = useState(sessionStorage.getItem('user_type'));
    const auth=useSelector(state=>state?.auth)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToHistory)
    const location = useLocation();
    const {UpdateCall,initialRoutePath,setInitialRoutePath,editSocket,setEditSocket}=useContext(GlobalContext)
    const restrict = useSelector((state)=>state?.systemConfigData?.restrict)
    const {loggedIn}=auth
    const editingUserId = useSelector((state)=>state?.systemConfigData?.editingUserId)
    const messageSent = useSelector((state)=>state?.systemConfigData?.messageSent)
    const navigate = useNavigate()
    
    
    const handleRefreshToken = async () => {
        if(sessionStorage.getItem('IdToken')){
            refreshIdToken()
        }
    };
    const fetchUserAttributes= useCallback(
  
        async() => {
            try {
                if(!auth.loggedIn && location.pathname!=='/reset-password' && location.pathname!=='/reset-new-password'){
                    navigate('/')
                    sessionStorage.setItem('custom:is_first_time_login', "false");

                }
                const user = await dataService.GetAPI('users/check-status');
                const userType = user?.data?.data?.user_type; 
                userType!==undefined?setCurrentUser(userType):setCurrentUser(sessionStorage.getItem('user_type'))
                dispactch(setUserType(userType));          
                
                setloading(false)
                // location(window.location.pathname)
            } catch (error) {
                
                if(sessionStorage.getItem('IdToken')){
                    refreshIdToken()
                    const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                    const user=sessionStorage.getItem('user_type')
                    setCurrentUser(user)
                    dispactch(setUserType(user))
                }
                setloading(false)
            }
        },
        [CurrentUser],
    )
    
  
    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
   effect is triggered when there are changes to the `loggedIn`, `fetchUserAttributes`, `logout`, or
   `GlobalChange` variables. */
    useEffect(() => {
        if(!loggedIn){

            setCurrentUser('')
            dispactch(resetState())
        }
        if(CurrentUser ===undefined || CurrentUser===''&&loggedIn){
            fetchUserAttributes();
        }
        setloading(false)
        
    
    }, [loggedIn,fetchUserAttributes,logout]);


    useEffect(()=>{
        
        const editRoutes = ['/manage-admin-corporate/add-admin-corporate/:id','/manage-organizations/add-organization/:id','/manage-provider/add-provider/:id','/manage-device-templates/edit-device-template/:id','/manage-devices/edit-device/:id','/manage-organizations/manage-organization-users/edit-organization-user/:id','/manage-monitoring-condition-templates/add-template/:id','/manage-observer/edit-observer/:id','/manage-patients/edit-patients/:id','/manage-monitor-user/add-monitor-user/:id']
        if(!editRoutes.includes(location.pathname)&&(editingUserId!==''||messageSent===true)){
            // dispactch(handleTargetUserEditId(''))
            // dispactch(handleEditMessageSent(false))
        }
        if(!location.pathname.includes('activity_history')){
            dispactch(handleIsViewScreen(['']))
        }
        if(!location.search.includes('filter')){
            dispactch(resetFilterState())
        }
        if(!location.pathname.includes('manage-organizations')){
            dispactch(handleIsUserScreen(['','']))
        }
        dispactch(resetArrays())
        if((!location.pathname.includes('add-organization'))&&(!location.pathname.includes('edit-patients'))){
            dispactch(resetOrgList())
            dispactch(resetMonitorList())
            dispactch(resetProviderList())
            dispactch(resetObserverList())
        }
        if(!location.pathname.includes('add-admin-corporate')){
            dispactch(resetSubDivList())
        }
        // if((sessionStorage.getItem("key")===location.pathname)){
        //     dispactch(handleSidebarAnimation(true))
        // }
        // else{
        //     dispactch(handleSidebarAnimation(false))
        // }
            
        sessionStorage.setItem('key',location.pathname)
    },[dispactch,location.pathname])


   

    return (

        <Suspense fallback={<div></div>}>{!loading &&
            <>
                <Routes location={location} key={location.pathname}>
                    <Route path="/email-address-verification" element={
                        <AnimatedPage>
                            <EmailVerificationScreen />
                        </AnimatedPage>
                    }/>
                    {(!loggedIn||(sessionStorage.getItem('custom:is_first_time_login')==="true"))?<>
                        <Route path="/" element={
                            <AnimatedPage><LoginPage /></AnimatedPage>} />
                        <Route path="/reset-password" element={
                            sessionStorage.getItem('custom:is_first_time_login') ? (
                                <AnimatedPage>
                                    <ResetPassword />
                                </AnimatedPage>
                            ) : (
                                <Navigate to="/" replace />
                            )} />
                        <Route path="/reset-new-password/" element={
                            <AnimatedPage><ForgotResetPassword /></AnimatedPage>} />
                        <Route path="/404" element={
                            <>
                                <SearchEmptyScreen text={"404"} />
                            </>} />  
                        {/* <Route
                            path="*"
                            element={
                                <Noroute/>
                            }
                        /> */}
                        <Route
                            path="*"
                            element={
                                <Navigate replace to='/'/>} 
                                
                        />
                    </>:(
                        ComponentsBasedOnRole[CurrentUser]&&
                        <Route path={'/'} element={<Layout/>}>
                            {restrict?(<><Route path={'/'} element={React.cloneElement(ComponentsBasedOnRole[CurrentUser][0].element, props)}  key={'/profile'}/><Route path={'/profile/update-password'} element={<UpdatePassword/>}  key={'/profile/update-password'}/></>):ComponentsBasedOnRole[CurrentUser]?.map((nav)=>(
                                ((CurrentUser === "super-admin"||CurrentUser === "admin-user" || CurrentUser==='corporate-user')) &&
                                !(nav.path === '/system-configuration' && CurrentUser === 'corporate-user') &&
                                <Route path={nav.path} element={React.cloneElement(nav.element, props)}  key={nav.path}/>
                            ))}
                            {restrict? <Route path="*" element={<Navigate to="/" />} />:<Route
                                path="*"
                                element={
                                    <>
                                        <SearchEmptyScreen text={"404"} />
                                    </>} 
                                
                            />}
                            {CurrentUser === 'corporate-user' && <Route path="/system-configuration" element={<Navigate to="/profile" />} />}
                            <Route path="/404" element={
                                <SearchEmptyScreen text={"404"} />
                            } />  
                        </Route>
                        
                    )
                    }
                   
                    <Route
                        path="*"
                        element={
                            <Noroute/>} 
                                
                    />
                    
                </Routes>
            </>
        }</Suspense>

    );
}